/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/require-default-props */
import React, { useRef, useEffect, useCallback, useState } from 'react';
import { Form } from '@unform/web';
import * as yup from 'yup';
import { format } from 'date-fns';
import { FormHandles } from '@unform/core';
import { useHistory } from 'react-router-dom';
import RechargeService from '../../../../services/recharge';
import DatePicker from '../../../../components/DatePicker';
import getValidationErrors from '../../../../utils/getValidationErrors';
import Modal from '../../../../components/Modal';
import Button from '../../../../components/Button';
import TableLoader from '../../../../components/TableLoader';
import { Container, FormWrapper, LinkModal, ModalContent } from './styles';
import { ButtonReCaptcha } from '../../../../components/ButtonReCaptcha';

interface CreateOrderByValueModalProps {
  show: boolean;
  title: string;
  type: string;
  cardNumber?: string;
  handleClose(): void;
  handleAdd(data: any): void;
  titular?: any;
}

const schema = yup.object().shape({
  start_date: yup.string().required('Data inicial Obrigatória'),
  end_date: yup.string().required('Data final Obrigatória'),
});

const CreateOrderByValueModalAsync: React.FC<CreateOrderByValueModalProps> = ({
  handleClose,
  handleAdd,
  show,
  type,
  cardNumber,
  title,
  titular,
}) => {
  const formTableRef = useRef<FormHandles>(null);
  const services = { RechargeService: new RechargeService() };
  const [loading, setLoading] = useState<boolean>(false);
  // const [modalRelatorio, setModalRelatorio] = useState(false);
  const [recharge, setRecharge] = useState<any>([]);
  const { push } = useHistory();
  console.log({ recharge });
  const handleGetRecharge = useCallback(async () => {
    try {
      const response = await services.RechargeService.getRechargeOrders();
      setRecharge(response.data.DadosDoCartao);
      // setModalRelatorio(true);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    handleGetRecharge();
  }, []);

  function relatorio() {
    push('/agendado');
  }

  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        {loading ? (
          <TableLoader />
        ) : (
          <>
            <Form ref={formTableRef} onSubmit={data => console.log(data)}>
              <DatePicker
                name="start_date"
                label="De"
                placeholder="Digite a data"
              />
              <DatePicker
                name="end_date"
                label="Até"
                placeholder="Digite a data"
              />
              <div className="buttonsContainer">
                <ButtonReCaptcha
                  disabled={titular?.BalanceView || false}
                  onClick={async (_: any, cb: any) => {
                    try {
                      formTableRef.current?.setErrors({});
                      const data: any = formTableRef.current?.getData();

                      const filterData = {
                        ...data,
                        'file-type': type,
                        end_date: data.end_date
                          ? format(data.end_date, 'dd/MM/yyyy')
                          : '',
                        'card-number': cardNumber,
                        start_date: data.start_date
                          ? format(data.start_date, 'dd/MM/yyyy')
                          : '',
                      };

                      await schema.validate(filterData, {
                        abortEarly: false,
                      });

                      setLoading(true);

                      await handleAdd(filterData);
                      setLoading(false);
                      handleClose();
                      cb();
                    } catch (err) {
                      if (err instanceof yup.ValidationError) {
                        const errors = getValidationErrors(err);
                        formTableRef.current?.setErrors(errors);
                      }
                      setLoading(false);
                    }
                  }}
                  modalTitle="EXTRATO PDF"
                  component={({ handle }) => (
                    <Button color="orange" padding="1" onClick={() => handle()}>
                      Gerar Relatório
                    </Button>
                  )}
                />
              </div>
            </Form>
          </>
        )}

        {/* {modalRelatorio && (
          <Modal
            handleClose={() => setModalRelatorio(false)}
            show={modalRelatorio}
            title="Agendamento de Relatório"
          >
            <ModalContent>
              <FormWrapper>
                <p>Estamos processando os dados do pedido do Relatório.</p>
                <p>
                  <LinkModal onClick={relatorio}>Clique Aqui!</LinkModal>
                  Para abrir o menu Relatórios Agendados e acompanhar o Pedido
                  solicitado. Quando este processo for finalizado basta fazer o
                  download do arquivo.
                </p>
              </FormWrapper>
            </ModalContent>
          </Modal>
        )} */}
      </Modal>
    </Container>
  );
};

export default CreateOrderByValueModalAsync;
